module.exports = "<div class=row> <div class=\"col s12\"> <h4 class=header>{{data.name}}</h4> <p>{{{data.description}}}</p> <real-demo :demo-name=data.demoComponentName></real-demo> <source-code :code=\"'\\r\\n' + data.code\"></source-code> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/components/example.vue
 ** module id = 372
 ** module chunks = 0
 **/